import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { LOGO_URL, isFireTvWrapper } from './tvAssets';

export const hasTvSubAccess = (user) =>
  !!user && (user.role === 'admin' || user.access_override || ['active', 'trialing'].includes(user.subscription_status));

export function TvSubRequired() {
  const { logout } = useAuth();
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Enter' || e.key === 'Escape' || e.key === 'Backspace' || e.keyCode === 10009 || e.keyCode === 461) {
        e.preventDefault(); e.stopPropagation();
        logout().catch(() => {}).finally(() => { try { sessionStorage.removeItem('activeProfile'); } catch { /* ignore */ } window.location.href = '/tv'; });
      }
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [logout]);
  return (
    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: '#0b0612',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}
      data-testid="tv-sub-required">
      <img src={LOGO_URL} alt="Maya+" style={{ height: '4vw', marginBottom: '2.2vw' }} />
      <h1 style={{ fontSize: '2.6vw', fontWeight: 800, color: '#fff', marginBottom: '1vw' }}>Abonnement requis</h1>
      <p style={{ fontSize: '1.3vw', color: 'rgba(255,255,255,0.7)', lineHeight: 1.6, maxWidth: '46vw', marginBottom: '0.6vw' }}>
        Votre compte n'a pas d'abonnement actif.
      </p>
      <p style={{ fontSize: '1.3vw', color: 'rgba(255,255,255,0.7)', lineHeight: 1.6, maxWidth: '46vw', marginBottom: '2.4vw' }}>
        {isFireTvWrapper
          ? "Un abonnement Maya+ actif est nécessaire pour utiliser cette application."
          : <>Rendez-vous sur <span style={{ color: '#E9641A', fontWeight: 800 }}>mayaplus.fr</span> pour choisir une offre, puis reconnectez-vous ici.</>}
      </p>
      <div className="tv-btn" style={{ padding: '0.7vw 2.4vw', borderRadius: '2.2vw', fontSize: '1.35vw', fontWeight: 800,
        background: '#fff', color: '#0b0612', cursor: 'pointer' }}
        onClick={() => { logout().catch(() => {}).finally(() => { window.location.href = '/tv'; }); }}
        data-testid="tv-sub-required-logout">
        Changer de compte
      </div>
    </div>
  );
}
